const countries = require('../utils/countries.json');

export default function getCountryFlagUrl(currencyCode) {
    return countries.find((item)=> item.currencyCode === currencyCode)?.flag || ""
}